class TabbedProducts {
  constructor(container) {
    this.container = container;
    this.tabs = container.querySelectorAll('.tabbed-products__tab');
    this.panels = container.querySelectorAll('.tabbed-products__panel');
    
    this.init();
  }

  init() {
    // Tab Click Events
    this.tabs.forEach(tab => {
      tab.addEventListener('click', (e) => this.handleTabClick(e));
    });

    // Initialize first tab and its swiper
    if (this.tabs.length > 0) {
      this.showPanel(this.tabs[0].dataset.tab, true);
    }
  }

  handleTabClick(e) {
    const clickedTab = e.currentTarget;
    const targetPanel = clickedTab.dataset.tab;

    // Update active tab
    this.tabs.forEach(tab => tab.classList.remove('active'));
    clickedTab.classList.add('active');

    // Show corresponding panel
    this.showPanel(targetPanel, false);
  }

  showPanel(panelId, isFirstLoad = false) {
    // Hide all panels
    this.panels.forEach(panel => {
      panel.classList.remove('active');
    });

    // Show target panel
    const targetPanel = this.container.querySelector(`[data-panel="${panelId}"]`);
    if (targetPanel) {
      targetPanel.classList.add('active');

      // Update progress bar
      this.updateProgressBar(targetPanel);

      // Initialize or update swiper
      setTimeout(() => {
        const productsSlider = targetPanel.querySelector('.products-slider');
        const swiperEl = targetPanel.querySelector('.swiper');
        
        if (productsSlider && swiperEl) {
          // Wenn Swiper bereits existiert, nur updaten
          if (swiperEl.swiper) {
            swiperEl.swiper.update();
            // Update progress bar on slide change
            swiperEl.swiper.on('slideChange', () => {
              this.updateProgressBar(targetPanel, swiperEl.swiper);
            });
          } else {
            // Sonst manuell initialisieren
            this.initializeSwiper(productsSlider, swiperEl, targetPanel);
          }
        }
      }, isFirstLoad ? 100 : 150);
    }
  }

  updateProgressBar(panel, swiper = null) {
    const progressBar = panel.querySelector('.tabbed-products__progress-bar-fill');
    if (!progressBar) return;

    if (swiper) {
      // Calculate progress based on swiper position
      const progress = ((swiper.activeIndex + 1) / swiper.slides.length) * 100;
      progressBar.style.width = `${Math.min(progress, 100)}%`;
    } else {
      // Initial state
      const swiperEl = panel.querySelector('.swiper');
      if (swiperEl && swiperEl.swiper) {
        const slides = swiperEl.swiper.slides.length;
        const progress = (1 / slides) * 100;
        progressBar.style.width = `${progress}%`;
      } else {
        progressBar.style.width = '0%';
      }
    }
  }

  initializeSwiper(slider, swiperEl, targetPanel) {
    const sectionId = slider.dataset.id;
    // Speed und Delay Berechnung exakt wie in popular-products
    const speed = (slider.dataset.speed || 1.1) * 1000;
    const delay = (slider.dataset.delay || 3) * 1000; 
    
    const autoplay = slider.dataset.autoplay === 'true';
    const stopAutoplay = slider.dataset.stopAutoplay === 'true';
    const showArrows = slider.dataset.showArrows === 'true';

    let autoplayParm = {};
    let arrowsParm = {};

    if (autoplay) {
      autoplayParm = {
        autoplay: {
          delay: delay,
          pauseOnMouseEnter: stopAutoplay,
          disableOnInteraction: false,
        },
      };
    }

    if (showArrows) {
      arrowsParm = {
        navigation: {
          nextEl: slider.querySelector('.swiper-button-next'),
          prevEl: slider.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: slider.querySelector('.products-slider-pagination'),
          clickable: true,
        },
      };
    }

    let swiperParams = {
      speed: speed,
      keyboard: true,
      
      // Identische Physik-Einstellungen wie Popular Products
      watchSlidesProgress: true,
      normalizeSlideIndex: true,
      resistanceRatio: 0,
      touchRatio: 1,
      threshold: 5,

      // Layout Einstellungen (2.2 / 3.2 / 4.3 mit 3px Gap)
      slidesPerView: 2.2,
      spaceBetween: 3, 
      slidesPerGroup: 1,

      breakpoints: {
        320: { 
          slidesPerView: 2.2,
          slidesPerGroup: 1,
          spaceBetween: 3, 
        },
        750: { 
          slidesPerView: 3.2,
          slidesPerGroup: 1,
          spaceBetween: 3,
        },
        990: { 
          slidesPerView: 4.3,
          slidesPerGroup: 1,
          spaceBetween: 3,
        },
        1200: { 
          slidesPerView: 4.3,
          slidesPerGroup: 1,
          spaceBetween: 3,
        }
      },
      
      on: {
        slideChange: (swiper) => {
          this.updateProgressBar(targetPanel, swiper);
        },
        init: (swiper) => {
          this.updateProgressBar(targetPanel, swiper);
        }
      },
      ...arrowsParm,
      ...autoplayParm,
    };

    // Initialisiere Swiper
    new Swiper(swiperEl, swiperParams);
    slider.classList.add('slider_started');
  }
}

// Initialize all tabbed products sections
document.addEventListener('DOMContentLoaded', () => {
  const tabbedProductsContainers = document.querySelectorAll('.tabbed-products');
  
  tabbedProductsContainers.forEach(container => {
    new TabbedProducts(container);
  });
});

// Handle Shopify section editor reload
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target.querySelector('.tabbed-products');
    if (container) {
      new TabbedProducts(container);
    }
  });
}